import { FC, HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import fireBallCallboard from '../../assets/apng/fireball-callboard.png';
import fireBallSmoke from '../../assets/apng/fireball-smoke.png';

export type CallBoardNumberContainerProps = {
    isCalled: boolean;
    // The designated Fire Ball is highlighted as special from game start.
    isFireBall?: boolean;
    isFireBallSnuffed?: boolean;
};

export type CallBoardNumberProps = HTMLAttributes<HTMLDivElement> & {
    number: number;
} & CallBoardNumberContainerProps;

export const CallBoardNumberContainer = styled.div<CallBoardNumberContainerProps>`
    display: inline-block;
    position: relative;
    font-family: Signika-SemiBold;
    font-size: 1.575rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: center;
    width: 2.25rem;
    height: 2.25rem;

    ${({ isCalled, theme }) => `
        color: ${theme.callBoard.color.number};
        opacity: ${isCalled ? '1' : '0.4'};
    `};

    ${({ isFireBall }) =>
        isFireBall
            ? css`
                  opacity: 1 !important;
                  color: #fff !important;
                  font-weight: 800;
                  text-shadow: 0 0.05rem 0.1rem rgba(0, 0, 0, 0.55);
              `
            : ''};
`;

const FireBallImage = styled.img`
    position: absolute;
    top: -2.5px;
    left: 50%;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
    transform: translateX(-50%);
    pointer-events: none;
    z-index: 0;
`;

const NumberText = styled.span`
    position: relative;
    z-index: 1;
`;

export const CallBoardNumber: FC<CallBoardNumberProps> = ({
    number,
    isCalled,
    isFireBall,
    isFireBallSnuffed,
    ...props
}) => {
    return (
        <CallBoardNumberContainer
            isCalled={isCalled}
            isFireBall={isFireBall}
            data-fireball={isFireBall ? 'true' : undefined}
            {...props}
        >
            {isFireBall && (
                <FireBallImage
                    src={isFireBallSnuffed ? fireBallSmoke : fireBallCallboard}
                    alt=""
                />
            )}
            <NumberText>{number}</NumberText>
        </CallBoardNumberContainer>
    );
};
